export enum ProductRegisterType {
	APPETIZER 	= { code: 'APPETIZER', description: 'PRODUCTS.APPETIZER' } as any,
	MAIN_COURSE = { code: 'MAIN_COURSE', description: 'PRODUCTS.MAIN_COURSE' } as any,
	DRINKS 		= { code: 'DRINKS', description: 'PRODUCTS.DRINK' } as any,
	DESSERTS 	= { code: 'DESSERTS', description: 'PRODUCTS.DESSERT' } as any,
	OTHERS 		= { code: 'OTHERS', description: 'PRODUCTS.OTHER' } as any
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/enum/product-register-type.enum.ts